function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { uuid } from 'uuidv4';
import { DateTime } from 'luxon';
import RiderSelector from '../RiderSelector';
import AgeGroupSelector from '../AgeGroupSelector';
import Workflow from '../Workflow';
import './AddRiderWorkflow.css';

var AddRiderWorkflow = /*#__PURE__*/function (_React$Component) {
  _inherits(AddRiderWorkflow, _React$Component);

  function AddRiderWorkflow(props) {
    var _this;

    _classCallCheck(this, AddRiderWorkflow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddRiderWorkflow).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onBack", function () {
      var _this$props = _this.props,
          cancelEntry = _this$props.cancelEntry,
          logBookEntry = _this$props.logBookEntry,
          updateLogBookEntryById = _this$props.updateLogBookEntryById;
      var _this$state = _this.state,
          activePanelIndex = _this$state.activePanelIndex,
          entry = _this$state.entry;

      switch (activePanelIndex) {
        case 0:
          logBookEntry.removeEntry(entry);
          updateLogBookEntryById(logBookEntry.id);
          return cancelEntry();

        default:
          return _this.setState({
            activePanelIndex: activePanelIndex - 1
          });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onForward", function (e) {
      var _this$props2 = _this.props,
          cancelEntry = _this$props2.cancelEntry,
          logBookEntry = _this$props2.logBookEntry,
          updateLogBookEntryById = _this$props2.updateLogBookEntryById;
      var _this$state2 = _this.state,
          activePanelIndex = _this$state2.activePanelIndex,
          panelNames = _this$state2.panelNames;

      if (activePanelIndex === panelNames.length - 1) {
        updateLogBookEntryById(logBookEntry.id);
        return cancelEntry();
      }

      var nextState = {
        activePanelIndex: activePanelIndex + 1
      };
      return _this.setState(nextState);
    });

    _this.state = {
      activePanelIndex: 0,
      panelNames: ['Select Rider', 'Select Age Group']
    };
    return _this;
  }

  _createClass(AddRiderWorkflow, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.show && prevProps.show !== this.props.show) {
        var entry = this.props.logBookEntry.addEntry();
        this.setState({
          entry: entry,
          activePanelIndex: 0
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var onBack = this.onBack,
          onForward = this.onForward;
      var _this$props3 = this.props,
          app = _this$props3.app,
          width = _this$props3.width,
          height = _this$props3.height,
          show = _this$props3.show,
          logBookEntry = _this$props3.logBookEntry,
          storage = _this$props3.storage,
          updateLogBook = _this$props3.updateLogBook;
      var _this$state3 = this.state,
          activePanelIndex = _this$state3.activePanelIndex,
          entry = _this$state3.entry,
          panelNames = _this$state3.panelNames;
      var panels = [];

      if (show && logBookEntry && entry) {
        panels.push(React.createElement(RiderSelector, {
          logBookEntry: logBookEntry,
          entry: entry,
          onSelect: onForward,
          storage: storage,
          updateLogBook: updateLogBook
        }));
        panels.push(React.createElement(AgeGroupSelector, {
          logBookEntry: logBookEntry,
          entry: entry,
          onSelect: onForward,
          storage: storage
        }));
      }

      return React.createElement(Workflow, {
        activePanelIndex: activePanelIndex,
        show: show,
        onBack: onBack,
        onForward: onForward,
        panels: panels,
        panelNames: panelNames,
        width: width,
        height: height
      });
    }
  }]);

  return AddRiderWorkflow;
}(React.Component);

export default AddRiderWorkflow;